import { Organization } from '../api';
import {
  UsersTab,
  OrganizationTab,
  PermissionsUsersSubTab,
  PermissionsGroupsSubTab,
  PermissionsProjectsSubTab,
  AuditLogsTab,
} from '../components/admin';

type AdminTab = 'people' | 'permissions' | 'organization' | 'audit';

interface AdminPageProps {
  organization: Organization | null;
  currentUserId?: string;
  activeTab: AdminTab;
  activeSubtab?: string;
  onTabChange: (tab: AdminTab) => void;
  onSubtabChange?: (subtab: string) => void;
}

export function AdminPage({
  organization,
  currentUserId,
  activeTab,
  activeSubtab = 'users',
  onTabChange,
  onSubtabChange,
}: AdminPageProps) {
  const authMethod = organization?.auth_method || 'password';

  return (
    <div className="page">
      <div className="page-header">
        <h1>Admin</h1>
        <p className="subtitle">Manage your organization, users, and permissions, and review activity</p>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'people' ? 'active' : ''}`}
          onClick={() => onTabChange('people')}
        >
          People
        </button>
        <button
          className={`tab-button ${activeTab === 'permissions' ? 'active' : ''}`}
          onClick={() => onTabChange('permissions')}
        >
          Permissions
        </button>
        <button
          className={`tab-button ${activeTab === 'organization' ? 'active' : ''}`}
          onClick={() => onTabChange('organization')}
        >
          Organization
        </button>
        <button
          className={`tab-button ${activeTab === 'audit' ? 'active' : ''}`}
          onClick={() => onTabChange('audit')}
        >
          Audit Logs
        </button>
      </div>

      <div className="admin-content">
        {/* People tab: Users (no sub-tabs) */}
        {activeTab === 'people' && (
          <UsersTab authMethod={authMethod} currentUserId={currentUserId} />
        )}

        {/* Permissions tab: Users + Groups + Projects sub-tabs */}
        {activeTab === 'permissions' && (
          <>
            <div className="admin-subtabs">
              <button
                className={`tab-button ${activeSubtab === 'users' ? 'active' : ''}`}
                onClick={() => onSubtabChange?.('users')}
              >
                Users
              </button>
              <button
                className={`tab-button ${activeSubtab === 'groups' ? 'active' : ''}`}
                onClick={() => onSubtabChange?.('groups')}
              >
                Groups
              </button>
              <button
                className={`tab-button ${activeSubtab === 'projects' ? 'active' : ''}`}
                onClick={() => onSubtabChange?.('projects')}
              >
                Projects
              </button>
            </div>
            {activeSubtab === 'users' && (
              <PermissionsUsersSubTab />
            )}
            {activeSubtab === 'groups' && (
              <PermissionsGroupsSubTab />
            )}
            {activeSubtab === 'projects' && (
              <PermissionsProjectsSubTab />
            )}
          </>
        )}

        {/* Organization tab */}
        {activeTab === 'organization' && organization && (
          <OrganizationTab organization={organization} />
        )}

        {/* Audit Logs tab */}
        {activeTab === 'audit' && <AuditLogsTab />}
      </div>
    </div>
  );
}
